import React from 'react';
import { Offer, useFeatureFlags } from '@funtech-int/yango-shared';

import { useOfferDisplayData } from '../../hooks/useOfferDisplayData';

import { DefaultPlan, WidePlan, YearAnnualPlan } from './plans';

interface MultiOfferPlanProps {
    withBadge: boolean;
    selected: boolean;
    offer: Offer;
    isWideMultiOfferDesktopEnabled: boolean;
    onClick: VoidFunction;
}

export const MultiOfferPlan = ({
    withBadge,
    selected,
    offer,
    isWideMultiOfferDesktopEnabled,
    onClick,
}: MultiOfferPlanProps) => {
    const { flags } = useFeatureFlags();
    const isNewYearAnnualOfferEnabled = flags.get('isNewYearAnnualOfferEnabled', 'boolean', false);

    const {
        title,
        subtitle,
        additionalText,
        priceText,
        badgeText,
        innerBadgeText,
        oldPrice,
        price,
        period,
        currency,
    } = useOfferDisplayData(offer);

    if (isWideMultiOfferDesktopEnabled) {
        return (
            <WidePlan
                badgeText={badgeText}
                selected={selected}
                title={title}
                subtitle={subtitle}
                additionalText={additionalText}
                priceText={priceText}
                onClick={onClick}
            />
        );
    }

    if (isNewYearAnnualOfferEnabled) {
        return (
            <YearAnnualPlan
                badgeText={innerBadgeText}
                selected={selected}
                title={title}
                subtitle={subtitle}
                price={price}
                currency={currency}
                period={period}
                onClick={onClick}
                oldPrice={oldPrice}
            />
        );
    }

    return (
        <DefaultPlan
            withBadge={withBadge}
            badgeText={badgeText}
            selected={selected}
            title={title}
            subtitle={subtitle}
            price={price}
            currency={currency}
            period={period}
            onClick={onClick}
        />
    );
};
